<template>
  <v-container
    fluid
    text-xs-center
    fill-height
    align-center
    style="padding:0; margin: 0;"
  >
    <v-layout
      :style="heightOverflow"
      align-center
      justify-center>
      <v-container
        grid-list-md
        align-center
        text-xs-center>
        <v-layout
          fill-height
          row
          wrap
          pt-4
          mt-4
          justify-space-between
          align-center
          style="min-height: 500px;"
        >
          <LeftLogo/>
          <v-spaced/>
          <v-flex
            md6
            xs12
            sm12
            class="login-content"
            style="min-width: 400px;"
            align-self-center>
            <v-spacer/>
            <v-layout
              column
            >
              <v-progress-linear
                v-if="loading"
                :indeterminate="true"
                class="progress-radius"
              />
              <v-card
                :class="$vuetify.breakpoint.width < 1200 ? 'login login-card-mobile' : 'login'"
                flat
              >
                <v-stepper v-model="step">
                  <v-stepper-header style="display: none;">
                    <v-stepper-step
                      :complete="step > 1"
                      step="1"
                    > Email
                    </v-stepper-step>

                    <v-divider/>

                    <v-stepper-step
                      :complete="step > 2"
                      step="2"
                    >Senha
                    </v-stepper-step>
                    <v-divider/>
                    <v-stepper-step
                      :complete="step > 3"
                      step="3"
                    >Repita Senha
                    </v-stepper-step>
                    <v-divider/>
                    <v-stepper-step
                      :complete="step > 4"
                      step="4"
                    >Nome
                    </v-stepper-step>
                    <v-divider/>
                    <v-stepper-step
                      :complete="step > 5"
                      step="5"
                    >Telefone
                    </v-stepper-step>

                  </v-stepper-header>

                  <v-stepper-items v-show="!cadastrando">
                    <v-stepper-content step="1">
                      <v-card-title style="text-align: center">{{ strings[idioma].botao_criar_conta }}</v-card-title>
                      <v-form
                        ref="form"
                        v-model="valid"
                        :lazy-validation="true"
                        style="padding-top: 24px;"
                        @submit.prevent="verificaEmail"
                      >
                        <v-text-field
                          ref="email"
                          :rules="emailRules"
                          v-model="email"
                          name="email"
                          label="E-mail"
                          outline
                          prepend-inner-icon="mdi-email"
                          required
                          autocomplete="off"
                          @focus="verificaErro"
                          @change="verificaErro"
                        />
                      </v-form>
                      <v-layout
                        :justify-center="$vuetify.breakpoint.xs"
                        :justify-space-between="$vuetify.breakpoint.smAndUp"
                        row
                        wrap
                      >
                        <v-btn
                          :disabled="loading"
                          flat
                          href="login"
                          color="primary">
                          Login
                        </v-btn>
                        <v-btn
                          :disabled="loading"
                          color="primary"
                          @click="verificaEmail">
                          {{ strings[idioma].botao_seguinte }}
                        </v-btn>
                      </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                      <v-card-title style="text-align: center">{{ strings[idioma].login_bem_vindo }}</v-card-title>
                      <div style="width: 100%; text-align: center">
                        <v-chip
                          v-model="chip"
                          close
                        >
                          <v-avatar>
                            <v-icon>mdi-account</v-icon>
                          </v-avatar>
                          {{ email }}
                        </v-chip>
                      </div>
                      <h4>{{ strings[idioma].digite_nome }}</h4>
                      <v-form
                        ref="formNome"
                        :lazy-validation="true"
                        style="padding-top: 0px;"
                        @submit.prevent="login"
                      >
                        <v-text-field
                          ref="name"
                          :rules="nameRules"
                          :type="'text'"
                          :label="strings[idioma].placeholder_name"
                          v-model="name"
                          name="name"
                          outline
                          counter
                          required
                        />
                      </v-form>
                      <v-layout
                        :justify-center="$vuetify.breakpoint.xs"
                        :justify-space-between="$vuetify.breakpoint.smAndUp"
                        row
                        wrap
                      >
                        <v-btn
                          :disabled="loading"
                          flat
                          small
                          color="primary"
                          style="margin-top: 12px;"
                          @click="step=1">
                          {{ strings[idioma].botao_voltar }}
                        </v-btn>
                        <v-btn
                          :disabled="loading"
                          color="primary"
                          @click="verificaNome()">
                          {{ strings[idioma].botao_seguinte }}
                        </v-btn>
                      </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                      <v-card-title style="text-align: center">{{ strings[idioma].login_bem_vindo }}</v-card-title>
                      <div style="width: 100%; text-align: center">
                        <v-chip
                          v-model="chip"
                          close
                        >
                          <v-avatar>
                            <v-icon>mdi-account</v-icon>
                          </v-avatar>
                          {{ email }}
                        </v-chip>
                      </div>
                      <div style="height: 350px; overflow: auto">
                        <Termos :eh-cadastro="true"/>
                      </div>
                      <v-layout
                        :justify-center="$vuetify.breakpoint.xs"
                        :justify-space-between="$vuetify.breakpoint.smAndUp"
                        row
                        wrap
                      >
                        <v-btn
                          :disabled="loading"
                          flat
                          small
                          color="primary"
                          style="margin-top: 12px;"
                          href="login">
                          {{ strings[idioma].nao_aceito }}
                        </v-btn>
                        <v-btn
                          :disabled="loading"
                          color="primary"
                          @click="step=4">
                          {{ strings[idioma].aceito }}
                        </v-btn>
                      </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="4">
                      <v-card-title style="text-align: center">{{ strings[idioma].login_bem_vindo }}</v-card-title>
                      <div style="width: 100%; text-align: center">
                        <v-chip
                          v-model="chip"
                          close
                        >
                          <v-avatar>
                            <v-icon>mdi-account</v-icon>
                          </v-avatar>
                          {{ email }}
                        </v-chip>
                      </div>
                      <div style="height: 350px; overflow: auto">
                        <Privacidade :eh-cadastro="true"/>
                      </div>
                      <v-layout
                        :justify-center="$vuetify.breakpoint.xs"
                        :justify-space-between="$vuetify.breakpoint.smAndUp"
                        row
                        wrap
                      >
                        <v-btn
                          :disabled="loading"
                          flat
                          small
                          color="primary"
                          style="margin-top: 12px;"
                          href="login">
                          {{ strings[idioma].nao_aceito }}
                        </v-btn>
                        <v-btn
                          :disabled="loading"
                          color="primary"
                          @click="step=5">
                          {{ strings[idioma].aceito }}
                        </v-btn>
                      </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="5">
                      <v-card-title style="text-align: center">{{ strings[idioma].login_bem_vindo }}</v-card-title>
                      <div style="width: 100%; text-align: center">
                        <v-chip
                          v-model="chip"
                          close
                        >
                          <v-avatar>
                            <v-icon>mdi-account</v-icon>
                          </v-avatar>
                          {{ email }}
                        </v-chip>
                      </div>
                      <v-form
                        ref="formPhone"
                        :lazy-validation="true"
                        style="padding-top: 0px; padding-bottom: 24px; overflow: auto; overflow-x: hidden; height: 300px;"
                        @submit.prevent="submit"
                      >
                        <v-layout
                          justify-center
                          wrap>
                          <v-flex
                            xs12
                            md12
                          >

                            <v-autocomplete
                              v-model="pais"
                              :label="'País'"
                              :items="Paises"
                              :item-text="(idioma === 0) ? 'nome' : 'nome_en'"
                              :item-value="'nome'"
                              :browser-autocomplete="rand()"
                              no-data-text=""
                              class="purple-input"
                              required
                            />
                          </v-flex>
                          <v-flex
                            v-if="pais === 'Brasil'"
                            xs12
                            md12
                          >
                            <v-text-field
                              v-model="cpf"
                              :rules="cpfRules"
                              autocorrect="off"
                              autocapitalize="none"
                              autocomplete="nope"
                              label="CPF"
                              maxlength="11"
                              class="purple-input"
                              return-value
                              mask="###.###.###-##"
                              required
                              @keypress.native="val => $validateOnlyNumbers(val)"
                              @change.native="val => !$testaCPF(cpf) ? cpf = '' : null"/>
                          </v-flex>
                          <v-flex
                            v-if="pais === 'Brasil'"
                            xs4
                            md4
                          >
                            <v-autocomplete
                              v-model="UF"
                              :label="'UF'"
                              :items="UnidadesFederativas"
                              :item-text="'sigla'"
                              :browser-autocomplete="rand()"
                              no-data-text=""
                              class="purple-input"
                              required
                            />
                          </v-flex>
                          <v-flex
                            v-if="pais === 'Brasil'"
                            xs8
                            md8
                          >
                            <v-autocomplete
                              v-model="cidade"
                              :label="'Cidade'"
                              :items="Cidades"
                              :browser-autocomplete="rand()"
                              no-data-text=""
                              class="purple-input"
                              required
                            />
                          </v-flex>
                        </v-layout>
                        <h4>{{ strings[idioma].digite_telefone }}</h4>
                        <v-layout
                          justify-center
                          wrap>
                          <v-flex md3>
                            <v-text-field
                              ref="telefone"
                              :type="'number'"
                              :label="strings[idioma].cod_pais"
                              v-model="cod_pais"
                              name="cod_pais"
                              maxlength="4"
                              outline
                              counter
                              required
                              @keypress.native="val => $validateOnlyNumbers(val)"
                            />
                          </v-flex>
                          <v-flex md3>
                            <v-text-field
                              v-if="pais === 'Brasil'"
                              ref="telefone"
                              :type="'number'"
                              :rules="dddRules"
                              :label="strings[idioma].DDD"
                              v-model="DDD"
                              name="phone"
                              maxlength="2"
                              outline
                              counter
                              required
                              @keypress.native="val => $validateOnlyNumbers(val)"
                            />
                            <v-text-field
                              v-else
                              ref="telefone"
                              :type="'number'"
                              :label="strings[idioma].DDD"
                              v-model="DDD"
                              name="ddd"
                              outline
                              counter
                              @keypress.native="val => $validateOnlyNumbers(val)"
                            />
                          </v-flex>
                          <v-flex md6>
                            <v-text-field
                              v-if="pais === 'Brasil'"
                              ref="telefone"
                              :type="'number'"
                              :rules="phoneRules"
                              :label="strings[idioma].placeholder_phone"
                              v-model="phone"
                              name="phone"
                              outline
                              counter
                              required
                              @keypress.native="val => $validateOnlyNumbers(val)"
                            />
                            <v-text-field
                              v-else
                              ref="telefone"
                              :type="'number'"
                              :label="strings[idioma].placeholder_phone"
                              v-model="phone"
                              name="phone"
                              outline
                              counter
                              @keypress.native="val => $validateOnlyNumbers(val)"
                            />
                          </v-flex>
                        </v-layout>
                      </v-form>
                      <v-layout
                        :justify-center="$vuetify.breakpoint.xs"
                        :justify-space-between="$vuetify.breakpoint.smAndUp"
                        row
                        wrap
                      >
                        <v-btn
                          :disabled="loading"
                          flat
                          small
                          color="primary"
                          style="margin-top: 12px;"
                          @click="step = 3">
                          {{ strings[idioma].botao_voltar }}
                        </v-btn>
                        <vue-recaptcha
                          ref="recaptcha"
                          size="invisible"
                          sitekey="6LdUf7sZAAAAAH7UJA4ROhLha5aC0EoDtdHmcic_"
                          @verify="onCaptchaVerified"
                          @expired="onCaptchaExpired">
                          <v-btn
                            :disabled="loading || (pais === 'Brasil' && ((cpf === null || cpf === '') || (cidade === null || cidade === '') || (UF === null || UF === ''))) || (pais === null || pais === '')"
                            color="primary"
                            @click="submit">
                            {{ strings[idioma].botao_seguinte }}
                          </v-btn>
                        </vue-recaptcha>
                      </v-layout>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-card>
            </v-layout>

          </v-flex>
          <!--<ContentDescription/>-->
        </v-layout>
        <!--<Footer/>-->
      </v-container>
    </v-layout>
  </v-container>
</template>
<style scoped>
.login-text{
  padding-top: 100px;

  overflow: auto;
}
.login-text div{
  -webkit-filter: blur(0px);
  -moz-filter: blur(0px);
  -o-filter: blur(0px);
  -ms-filter: blur(13px);
  filter: blur(0px);

  -webkit-backdrop-filter: blur(5px); /* Safari 9+ */
  backdrop-filter: blur(5px); /* Chrome and Opera */

  overflow: auto;
}
.login-content::before {
  min-height: 900px;
}
.login-content{

  padding: 30px;

  -webkit-filter: blur(0px);
  -moz-filter: blur(0px);
  -o-filter: blur(0px);
  -ms-filter: blur(13px);
  filter: blur(0px);
  max-height: 700px; overflow: auto;
  overflow-y: hidden;
  overflow-x: hidden;
  opacity: 0.7;
  transition: opacity 2s;
  -webkit-backdrop-filter: blur(5px); /* Safari 9+ */
  backdrop-filter: blur(5px); /* Chrome and Opera */
}
.login-content:hover{
  opacity: 1;
  transition: opacity 2s;
}
.login-card-mobile {
  padding: 0px;
}
</style>
<script>
import {
  mapState
} from 'vuex'
import Footer from './components/FreePages/Footer'
import ContentDescription from './components/FreePages/ContentDescription.vue'
import LeftLogo from './components/FreePages/LeftLogo.vue'
import { estados, paises } from '../lang/Strings'
import Termos from './statics/Termos'
import Privacidade from './statics/Privacidade'
import VueRecaptcha from 'vue-recaptcha'
export default {
  components: {
    VueRecaptcha,
    Termos,
    Privacidade,
    LeftLogo,
    ContentDescription,
    Footer
  },
  data () {
    return {
      cadastrando: false,
      background: 'img/drawer-bg.jpg',
      chip: true,
      email: null,
      emailError: false,
      emailErrorMessage: null,
      emailRules: [
        v => !!v || this.strings[this.idioma].email_obrigatorio,
        v => /.+@.+/.test(v) || this.strings[this.idioma].email_invalido,
        v => {
          if (this.emailError) {
            return this.emailErrorMessage
          }
          return false
        }
      ],
      loading: false,
      logando: false,
      logo: process.env.VUE_APP_LOGO_AZUL ? process.env.VUE_APP_LOGO_AZUL : 'img/brcorte-logo.png',
      password: null,
      password2: null,
      cpfRules: [
        async value => {
          if (value !== null && String(value).trim() !== '' && !this.$testaCPF(value)) {
            if (value.length >= 11) {
              this.$store.commit('openOKModal', { title: this.strings[this.idioma].atencao_erro, msg: this.strings[this.idioma].cpf_invalido, error: true })
            }
            return (value.length >= 11) ? this.strings[this.idioma].cpf_invalido : '.'
          } else if (value !== null && String(value).trim() !== '' && value.length >= 12) {
            return this.strings[this.idioma].cpf_minimo
          } else {
            return this.axios.post('users/verificaCPF', { cpf: value }).then(_ => {
              this.cpf = ''
              this.$store.commit('openOKModal', { title: this.strings[this.idioma].atencao_erro, msg: this.strings[this.idioma].cpf_ja_existente, error: true })

              return this.strings[this.idioma].cpf_existente
            })
          }
        }
      ],
      passwordRules: [
        value => !!value || this.strings[this.idioma].senha_obrigatorio,
        value => {
          if (this.passwordError) {
            return this.passwordErrorMessage
          }
          return false
        }
      ],
      password2Rules: [
        value => (this.password !== value) && this.strings[this.idioma].senhas_nao_batem,
        value => !!value || this.strings[this.idioma].senha_obrigatorio,
        value => {
          if (this.passwordError) {
            return this.passwordErrorMessage
          }
          return false
        }
      ],
      name: null,
      nameRules: [
        value => !!value || this.strings[this.idioma].requerido,
        value => !!String(value).trim() || this.strings[this.idioma].requerido
      ],
      phone: null,
      phoneRules: [
        value => !!value || this.strings[this.idioma].requerido,
        value => !!String(value).trim() || this.strings[this.idioma].requerido,
        value => String(value).trim().length >= 3 || (this.strings[this.idioma].requer_caracteres).format(3)

      ],
      dddRules: [
        value => !!value || this.strings[this.idioma].requerido,
        value => !!String(value).trim() || this.strings[this.idioma].requerido,
        value => String(value).trim().length === 2 || (this.strings[this.idioma].requer_numero).format(2)

      ],
      show1: false,
      step: 1,
      valid: null,
      validPassword: null,
      cod_pais: 55,
      DDD: null,
      cpf: null,
      pais: 'Brasil',
      UF: null,
      cidade: null,
      intervalGoogle: null
    }
  },
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'token', 'links_']),
    UnidadesFederativas () {
      return estados
    },
    Cidades () {
      let cidades = estados.filter(e => e.sigla === this.UF)
      return cidades.length > 0 ? cidades[0].cidades : []
    },
    Paises () {
      return paises
    },
    heightOverflow () {
      return 'margin: 0; padding: 20px; max-height: ' + String(this.$vuetify.breakpoint.height) + 'px; overflow: auto;'
    }
  },
  watch: {
    'chip' (val) {
      if (!val) {
        this.step = 1
        this.$refs.form.reset()
        this.$refs.formSenha.reset()
        this.chip = true
      }
      if (this.logando) {
        this.chip = true
      }
    },
    'pais' (val) {
      let pais = this.Paises.filter(p => p.nome === val)[0]
      this.cod_pais = parseInt(pais.fone)
    },
    'step' (val) {
      if (parseInt(val) === 1) {
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$nextTick(() => this.$refs.email.focus())
          })
        })
      } else if (parseInt(val) === 2) {
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$nextTick(() => this.$refs.name.focus())
          })
        })
      } else {
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$nextTick(() => this.$refs.phone.focus())
          })
        })
      }
    },
    'password' (val) { this.passwordError = false },
    'idioma' (val) {
      try {
        this.$refs.formSenha.validate()
        this.$refs.email.validate()
      } finally {
        window.location.href = window.location.href
      }
    }
  },
  mounted () {
    if (this.user !== null || !this.$store.state.app.permiteCadastro) window.location.href = '/'
    this.$nextTick(() => this.$refs.email.focus())
  },
  methods: {
    async create () {
      if (this.$refs.formPhone.validate()) {
        this.loading = this.cadastrando = true
        this.axios.post('auth/cadastraEmail', { email: this.email.trim() }).then(response => {
          this.axios.post('auth/cadastraNome', { email: this.email.trim(), username: this.name.trim() }).then(response => {
            this.axios.post('auth/cadastraDadosLocalizacao', { email: this.email.trim(), DDD: this.DDD, cod_pais: this.cod_pais, phone: this.phone, pais: this.pais, cpf: this.cpf, estado: this.UF, cidade: this.cidade }).then(res => {
              this.$router.push('/login')
              this.loading = this.cadastrando = false
              let msg = this.strings[this.idioma].cadastrado_com_sucesso
              let title = this.strings[this.idioma].botao_criar_conta
              this.$store.commit('openOKModal', { title, msg })
            }).catch(reason => {
              this.loading = this.cadastrando = false
              let msg = reason.message
              let time = 6000
              this.$store.commit('openErrorAlert', { msg, time })
              // console.log(reason)
            })
          }).catch(reason => {
            this.loading = this.cadastrando = false
            let msg = reason.message
            let time = 6000
            this.$store.commit('openErrorAlert', { msg, time })
            // console.log(reason)
          })
        }).catch(reason => {
          this.loading = this.cadastrando = false
          let msg = reason.message
          let time = 6000
          this.$store.commit('openErrorAlert', { msg, time })
          // console.log(reason)
        })
      } else {

      }
    },
    submit () {
      // this.status = "submitting";
      if (process.env.VUE_APP_PRODUCTION === true) {
        console.log('deu ruim 2')
        this.$refs.recaptcha.execute()
      } else {
        this.verificaEmail()
        this.create()
      }
      let count = 0
      this.intervalGoogle = setInterval(() => {
        count++
        if (count > 10) {
          clearInterval(this.intervalGoogle)
          this.verificaEmail()
          this.create()
        }
      }, 100)
    },
    onCaptchaVerified (recaptchaToken) {
      const self = this
      self.$refs.recaptcha.reset()
      if (recaptchaToken !== '' || recaptchaToken !== null) clearInterval(this.intervalGoogle)
      this.verificaEmail()
      this.create()
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
      clearInterval(this.intervalGoogle)
    },
    login () {
      this.$refs.formSenha.validate()
      if (this.validPassword) {
        this.loading = true
        this.axios.post('auth/appLogin', { email: this.email.trim(), password: this.password.trim() }).then(response => {
          this.loading = false
          localStorage.setItem('user-token', response.data.data.token)
          localStorage.setItem('user', JSON.stringify(response.data.data.user))
          this.$store.commit('setUser', response.data.data.user)
          this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.data.token
          this.$router.push('/')
        }).catch(error => {
          this.loading = false
          this.passwordError = true
          this.passwordErrorMessage = error.response.data.errors.message[this.idioma]
          this.$refs.formSenha.validate()
        })
      }
    },
    verificaEmail () {
      this.$refs.form.validate()
      if (this.valid) {
        this.loading = true
        this.email = this.email.toLowerCase()
        if (this.email === null) return
        this.axios.post('/auth/verificaEmail', { email: this.email.trim().toLowerCase() }).then(response => {
          this.loading = false
          this.emailError = true
          this.emailErrorMessage = this.strings[this.idioma].email_ja_existe
          this.$refs.form.validate()
        // eslint-disable-next-line handle-callback-err
        }).catch(error => {
          this.email = this.email.trim().toLowerCase()
          this.loading = false
          if (this.step < 3) {
            this.step = 2
          }
        })
      }
    },
    verificaRepitaSenha () {
      if (this.$refs.formRepitaSenha.validate()) {
        this.loading = false
        this.step++
      }
    },
    verificaNome () {
      if (this.$refs.formNome.validate()) {
        this.loading = false
        this.step++
      }
    },
    verificaTelefone () {
      if (this.$refs.formPhone.validate()) {
        this.loading = false
        this.step++
      }
    },
    verificaErro () {
      if (this.emailError) {
        this.emailError = false
        this.emailErrorMessage = null
        this.$refs.form.validate()
      }
    },
    verificaErroPassword () {
      if (this.passwordError) {
        this.passwordError = false
        this.passwordErrorMessage = null
        this.$refs.formSenha.validate()
      }
    }
  }
}
</script>
